import { gql, useMutation } from "@apollo/client";
import {
  Box,
  Icon,
  IconButton,
  Tooltip,
} from "@mui/material";
import * as React from "react";

import * as gqlb from "gql-query-builder";
import { useTranslation } from "react-i18next";
import config from "../../config.json";

export const EXPOERT_ACCOUNT_STATEMENT = gqlb.mutation({
  operation: "exportJournalEntries",
  variables: {
    filters: {
      type: "ListJournalEntryRecordsInput",
      required: true,
    },
  },
});

export default function ExportAccountStatement(props) {
  const { filters, disabled } = props;

  const { t } = useTranslation();

  let getBackendUri = (imgPath) => {
    const domain = config.backend.domain
      ? config.backend.domain
      : window.location.hostname;

    return `${config.backend.protocol}://${domain}:${config.backend.port}/${imgPath}`;
  };
  const [ExportAccountStatements] = useMutation(
    gql`
      ${EXPOERT_ACCOUNT_STATEMENT.query}
    `,
    {
      onCompleted: (data) => {
        const path = data.exportJournalEntries;
        window.open(getBackendUri(path));
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  const handelExportAccountStatement = () => {
    ExportAccountStatements({
      variables: {
        filters: {
          fromDate: filters.fromDate,
          toDate: filters.toDate,
          glAccountId: filters.glAccountId,
          approved: true
        }
      },
    });
  };


  return (
    <>
      <Tooltip title={t("exportExcel")}>
        <Box component="span">
          <IconButton
            disabled={disabled}
            onClick={() => handelExportAccountStatement()}
            size="large"
          >
            <Icon>sim_card_download</Icon>
          </IconButton>
        </Box>
      </Tooltip>
    </>
  );
}

